<template>
	<ViewFeedItem class="view-feed-hallsnearby">
		<template v-slot:header>
			<ViewLayoutModuleHeader title="Nearest pool halls">
				<RouterLink v-bind:to="{ name: 'PagePlaces' }">
					<strong>View All</strong>
				</RouterLink>
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyVenueList
				class="horizontal"
				v-bind:useLocation="true"
				v-bind:venueCollection="venueCollection"
				v-on:venue:select="Handle_OnSelectVenue"
			/>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import * as Factory from '@/App/Factory';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, event, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedHallsMNearby extends ViewBase {
		/**
		 * @type ChalkySticks/Collection/Venue
		 */
		@Prop({
			default: () =>
				Factory.Venue.collection({
					limit: 8,
					qp: {
						type: 'hall',
					},
				}),
		})
		public venueCollection!: ChalkySticks.Collection.Venue;

		/**
		 * @return void
		 */
		@mounted
		public setup(): void {
			this.venueCollection.fetch();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.$store.dispatch('gotoVenue', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-hallsnearby {
		--chalky-utility-gallery-aspect-ratio: 4 / 3;
	}
</style>
